import { DateTime } from 'luxon';
import {
  Section,
  ReadOnlyField,
  Stack,
} from '@fashionnovateam/nova-ui-toolkit';
import { VendorCatalogItem } from '../../../../Lib/Hooks/ItemService';

type StockDetailsSectionProps = {
  item: VendorCatalogItem | undefined;
};

function StockDetailsSection({ item }: StockDetailsSectionProps) {
  return (
    <Section
      icon="package/package-02"
      title="Stock Details"
      color="white"
      iconVariant="solid"
      separateHeader={false}
      withoutShadow
      iconColor="black"
      data-testid="stock-details-readonly-section"
    >
      <Stack direction="col" className="gap-3">
        <Stack direction="row" className="gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Stock Qty"
            value={item?.stock_quantity}
            suffix="units"
            id="stock-qty"
          />
          <ReadOnlyField
            className="flex-1"
            label="Stock Ratio"
            value={item?.stock_ratio}
            id="stock-ratio"
          />
          <ReadOnlyField
            className="flex-1"
            label="Earliest IHD Date to Deliver Stock"
            value={
              item?.stock_ihd
                ? DateTime.fromJSDate(new Date(item?.stock_ihd), {
                    zone: 'utc',
                  }).toFormat('DD')
                : undefined
            }
            id="earliest-ihd-date-to-deliver-stock"
          />
        </Stack>
        <div className="flex flex-row w-full gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Incoming Stock Qty"
            suffix="units"
            value={item?.incoming_stock_quantity}
            id="incoming-stock-qty"
          />
          <ReadOnlyField
            className="flex-1"
            label="Incoming Stock Ratio"
            value={item?.incoming_stock_ratio}
            id="incoming-stock-ratio"
          />
          <ReadOnlyField
            className="flex-1"
            label="Incoming Stock Date"
            value={
              item?.incoming_stock_date
                ? DateTime.fromJSDate(new Date(item?.incoming_stock_date), {
                    zone: 'utc',
                  }).toFormat('DD')
                : undefined
            }
            id="incoming-stock-date"
          />
        </div>
      </Stack>
    </Section>
  );
}

export default StockDetailsSection;
